import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';
import { ProgressBar } from 'mw-style-react';
import './PreviewPDF.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PreviewPDF({ file }) {
  const [pagesCount, setPagesCount] = useState(1);
  const [scale, setScale] = useState(1);
  const [originalSize, setOriginalSize] = useState(true);
  const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
  };

  const handleKeyDown = (e) => {
    e.preventDefault();
    if (e.code === 'Equal') {
      setScale(scale * 1.5);
    } else if (e.code === 'Minus' && scale > 0.5) {
      setScale(scale * 0.5);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  useEffect(() => {
    setScale(1);
    setOriginalSize(true);
  }, [file]);

  const onDocumentLoad = ({ numPages }) => {
    setPagesCount(numPages);
  };

  const onPageLoad = (page) => {
    const parentDiv = document.getElementById('pdfDocument');
    const pageScale = parentDiv.clientWidth / page.originalWidth;
    if (scale !== pageScale && originalSize) {
      setScale(pageScale);
      setOriginalSize(false);
    }
  };

  const preloader = (
    <div styleName="pdf__loader">
      <ProgressBar type="circle" size="medium" />
    </div>
  );

  return (
    <div styleName="pdf">
      <div
        id="pdfDocument"
        styleName="pdf__document"
        onClick={(e) => e.stopPropagation()}
      >
        <Document
          file={file}
          options={options}
          loading={preloader}
          onLoadSuccess={onDocumentLoad}
        >
          {Array.from(new Array(pagesCount), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              loading={preloader}
              onLoadSuccess={onPageLoad}
              scale={scale}
            />
          ))}
        </Document>
      </div>
    </div>
  );
}

PreviewPDF.propTypes = {
  file: PropTypes.string.isRequired,
};

export default PreviewPDF;
